/**
 * A modal dialog's backdrop (ADR 0191), in place of Radix's Dialog.Overlay:
 * the dimmed layer behind the dialog, where a click closes it. While it's
 * there the page behind is held still (lockPageScroll), without the inline
 * <style> element that Radix's own scroll lock adds, which the Content
 * Security Policy refuses. It goes in the dialog's Dialog.Portal, which shows
 * it only while the dialog is open.
 *
 * Everything else stays Radix's: focus kept inside, the rest of the page
 * hidden from a screen reader, Escape, and a click outside.
 */
import { type ComponentPropsWithRef, useLayoutEffect } from "react";

import { lockPageScroll } from "../../lib/pageScrollLock";

export function DialogBackdrop({ style, ...props }: ComponentPropsWithRef<"div">) {
  // Before the browser paints: the scroll bar goes as the backdrop appears.
  useLayoutEffect(() => lockPageScroll(), []);
  // A modal dialog turns off pointer events on the rest of the page; the
  // backdrop takes them again, as Radix's own does, so a click on it closes
  // the dialog. React sets a style through the CSSOM, which the CSP allows.
  return <div {...props} style={{ pointerEvents: "auto", ...style }} />;
}
